const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
    '& th': {
      color: 'black',
      fontSize: "16px",
      fontWeight: "bold"
    },
    '& thead': {
      borderTop: '1px solid #ebebeb',
      fontSize: "16px",
    },
    '& td': {
      fontSize: "16px"
    }
  },
  pass: {
    color: "#43A547"
  },
  fail:{
    color: "#ff5252"
  },
  fiberImage: {
    width: 160,
    height: 130,
    resizeMode: 'contain'
  },
  fiberQualImage: {
    width: 160,
    height: 180,
    resizeMode: 'contain'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/common/results/views/fiber/types/components/fiberlengthlossinslosstable/styles.js